<template>
    <div class="choosen-card">
        <div class="d-flex align-items-center justify-content-between ">
            <h3>{{ $t('Your Card') }}</h3>
            <div class="label-card">
            <div v-if="data">{{ $t(data.type) }}</div>
            </div>
        </div>
        <div class="d-flex">
            <div class="card-info" :class="data && data.card_fee>0?'w-65':''">
            <small>{{ $t('Card Type') }}</small>
            <p v-if="data">{{ $t(data.name) }} </p>
            </div>
            <div class="card-info" v-if="data && data.card_fee>0">
              <small>{{ $t('Card Fee') }}</small>
              <p>{{ data.currency }} {{ parseFloat(data.card_fee).toFixed(2) }}</p>
            </div>
        </div>
        
        <img :src="image?image:(data?data.image:'')" class="w-100" />
        </div>
</template>

<script>
export default {
  data() {
    return {
      image : '',
      publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
    }
  },
  components:{
      
  },
  props:['data'],
  methods:{
    changeImage(img){
      if(img){
        console.log(img);
        this.image = img; 
      }
    }
  },
  mounted(){
    
  }
}
</script>